import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import LoadingSpinner from '../components/LoadingSpinner';
import ViralReferralBanner from '../components/ViralReferralBanner';
import ActivateDualRoleBanner from '../components/ActivateDualRoleBanner';

const UserDashboard = () => {
  const { user } = useAuth();
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBookings = async () => {
      try {
        const { bookingsAPI } = await import('../api');
        const response = await bookingsAPI.getAll();
        setBookings(response.data);
      } catch (error) {
        console.error('Error fetching bookings:', error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchBookings();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-ink-50 py-6 sm:py-10 font-mont">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-comfortaa font-bold text-2xl sm:text-3xl text-ink mb-1">Mi Dashboard</h1>
        <p className="text-sm text-ink-500 font-light mb-6">Tus reservas y créditos en Mobility.</p>
        <ActivateDualRoleBanner target="mobilitier" />
        <ViralReferralBanner />
        <div className="grid grid-cols-3 gap-3 sm:gap-4 mb-6 sm:mb-8">
          <Card className="border-ink-100">
            <CardHeader className="p-4 sm:p-5 pb-1"><CardTitle className="text-xs font-comfortaa font-bold tracking-wider uppercase text-ink-500">Totales</CardTitle></CardHeader>
            <CardContent className="p-4 sm:p-5 pt-0"><p className="font-comfortaa font-bold text-2xl sm:text-3xl text-ink">{bookings.length}</p></CardContent>
          </Card>
          <Card className="border-ink-100 bg-lime">
            <CardHeader className="p-4 sm:p-5 pb-1"><CardTitle className="text-xs font-comfortaa font-bold tracking-wider uppercase text-ink-800">Activas</CardTitle></CardHeader>
            <CardContent className="p-4 sm:p-5 pt-0">
              <p className="font-comfortaa font-bold text-2xl sm:text-3xl text-ink">
                {bookings.filter(b => b.status === 'active' || b.status === 'confirmed').length}
              </p>
            </CardContent>
          </Card>
          <Card className="border-ink-100">
            <CardHeader className="p-4 sm:p-5 pb-1"><CardTitle className="text-xs font-comfortaa font-bold tracking-wider uppercase text-ink-500">Completadas</CardTitle></CardHeader>
            <CardContent className="p-4 sm:p-5 pt-0">
              <p className="font-comfortaa font-bold text-2xl sm:text-3xl text-ink">
                {bookings.filter(b => b.status === 'completed').length}
              </p>
            </CardContent>
          </Card>
        </div>
        <Card className="border-ink-100">
          <CardHeader><CardTitle className="font-comfortaa text-lg">Mis Reservas</CardTitle></CardHeader>
          <CardContent>
            {bookings.length > 0 ? (
              <div className="divide-y divide-ink-100">
                {bookings.map(booking => (
                  <div key={booking.id} className="py-3 sm:py-4 first:pt-0 last:pb-0">
                    <div className="flex justify-between items-start gap-3">
                      <div className="min-w-0">
                        <h3 className="font-comfortaa font-bold text-ink truncate">{booking.car_name || `Auto #${booking.car_id}`}</h3>
                        <p className="text-xs sm:text-sm text-ink-500 font-light mt-0.5">
                          {new Date(booking.start_date).toLocaleDateString()} → {new Date(booking.end_date).toLocaleDateString()}
                        </p>
                        <p className="text-xs sm:text-sm text-ink-700 font-medium mt-0.5">${booking.total_price} MXN · {booking.days} días</p>
                      </div>
                      <Badge variant="outline" className="shrink-0">{booking.status}</Badge>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-ink-500 text-center py-8 font-light">No tienes reservas aún</p>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default UserDashboard;
